<template>
  <div class="pb-3" >
    <va-card :title="$t(`seasons.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Temporada" v-slot="{ errors }">
                <va-input
                  v-model="season.temporada"
                  :label="$t('seasons.forms.temporadaLabel')"
                  :placeholder="$t('seasons.forms.temporadaPlaceholder')"
                  :success="errors.length == 0 && season.temporada.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Temporada" v-slot="{ errors }">
                <va-input
                  v-model="order"
                  :label="$t('seasons.forms.orderLabel')"
                  :placeholder="$t('seasons.forms.orderPlaceholder')"
                  :success="errors.length == 0 && order > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="ID da API" v-slot="{ errors }">
                <va-input
                  v-model="api"
                  :label="$t('seasons.forms.idApiLabel')"
                  :placeholder="$t('seasons.forms.idApiPlaceholder')"
                  :success="errors.length == 0 && api > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <label>{{$t('seasons.forms.isActivePlaceholder')}}</label>
              <va-toggle
                v-model="season.isActive"
                small
                :label="season.isActive ? 'Sim' : 'Não'"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'SeasonsAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
    championship: {
      required: true,
    },
  },
  computed: {
    order: {
      get () {
        return this.season.order
      },
      set (value) {
        if (value > 0) {
          this.season.order = value
        }
      },
    },
    api: {
      get () {
        return this.season.idApi
      },
      set (value) {
        if (value > 0) {
          this.season.idApi = value
        }
      },
    },
  },
  data () {
    return {
      season: {
        temporada: '',
        idApi: 0,
        order: 0,
        isActive: false,
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.season.temporada = ''
    this.season.order = 0
    this.season.idApi = 0
    this.season.isActive = false
    if (this.updateData !== null) {
      this.season_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.season_get(this.updateData)
      } else {
        this.season.temporada = ''
        this.season.order = 0
        this.season.idApi = 0
        this.season.isActive = false
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    season_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'is_active') {
            this.season.isActive = data[value]
          } else if (value === 'id_api') {
            this.season.idApi = data[value]
          } else {
            this.season[value] = data[value]
          }
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { temporada, order, idApi, isActive } = this.season
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($temporada: String, $order: Int,, $id_api: Int, $is_active: Boolean, $id: Int!) {
                  update_season_by_pk(pk_columns: {id: $id}, _set: {temporada: $temporada, order: $order, id_api: $id_api, is_active: $is_active}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($temporada: String, $order: Int, $id_api: Int, $is_active: Boolean, $championship_id: Int!) {
                  insert_season(objects: {temporada: $temporada, order: $order, id_api: $id_api, is_active: $is_active, championship_id: $championship_id}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            temporada,
            order,
            id_api: idApi,
            is_active: isActive,
            id: this.season.id,
          } : {
            temporada,
            order,
            id_api: idApi,
            is_active: isActive,
            championship_id: this.championship,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.season.temporada = ''
          self.season.order = 0
          self.season.idApi = 0
          self.season.isActive = false
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.season.temporada = ''
          self.season.order = 0
          self.season.idApi = 0
          self.season.isActive = false
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
